var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classify-card"},[_c('h2',{staticClass:"classify-card-title",domProps:{"textContent":_vm._s(_vm.title)}}),_c('van-divider',{staticStyle:{"margin":"0 0"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }